// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Icon__Jsx3 = require("../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");

function ReadMoreButton(props) {
  var children = props.children;
  return JsxRuntime.jsxs(ButtonsV5.OutlineButton.make, {
              href: props.href,
              size: "medium",
              className: "uppercase text-tan-blue-500 border-zinc-300 flex",
              children: [
                JsxRuntime.jsx("span", {
                      children: children !== undefined ? Caml_option.valFromOption(children) : "read more",
                      className: "mr-16"
                    }),
                JsxRuntime.jsx(Icon__Jsx3.make, {
                      icon: "ArrowRight",
                      size: 14
                    })
              ]
            });
}

var make = ReadMoreButton;

exports.make = make;
/* ButtonsV5 Not a pure module */
